import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useSearchParam } from "@/common/hooks/useSearchParam";

export function useFeatureViewParam() {
  const { appId } = useEnvironment();

  return useSearchParam("view", {
    storage: localStorage,
    storageKey: `${appId}:view`,
  });
}
